const REDIRECT_ENDPOINT = `/services/oauth2/echo`;
const AUTHORIZE_ENDPOINT = `/services/oauth2/authorize`;
const REQUEST_TOKEN_ENDPOINT = `/services/oauth2/token`;
const REVOKE_TOKEN_ENDPOINT = `/services/oauth2/revoke`;
const ISSUER_URL = import.meta.env.VITE_SALESFORCE_OIDC_ISSUER_URL;

export const CLIENT_ID = import.meta.env.VITE_SALESFORCE_OIDC_CLIENT_ID;
export const AUTHORIZE_URI = ISSUER_URL + AUTHORIZE_ENDPOINT;
export const REQUEST_TOKEN_URI = ISSUER_URL + REQUEST_TOKEN_ENDPOINT;
export const REDIRECT_URI = ISSUER_URL + REDIRECT_ENDPOINT;
export const REVOKE_TOKEN_URI = ISSUER_URL + REVOKE_TOKEN_ENDPOINT;

// OCI-specific
export const OCI_TRANSFER_METADATA_STORAGE_KEY = "ociTransferMetaData";
export const OCI_TRANSFER_METADATA_DEFAULTS = {
  okCode: "ADDI",
  caller: "CTLG",
  target: "_top",
};
